<template>
  <div class="wrapper" :class="{ mobile: isMobile }">
    <h5>
      Top triggers
      <span>(last 7 days)</span>
    </h5>
    <div v-if="!topTriggerList || !topTriggerList.length">
      No top triggers in the last 7 days.
    </div>
    <ul>
      <li v-for="(trigger, index) in topTriggerList" :key="index">
        <p>{{ trigger }}</p>
        <p @click="viewDetails(trigger)" class="view-details">
          View details
        </p>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
  name: 'TopTriggerCard',
  props: {
    topTriggerList: {
      type: Array,
      required: true
    }
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters(['isMobile'])
  },
  methods: {
    viewDetails(trigger) {
      this.$emit('onViewDetails', trigger);
    }
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  padding: 1.5rem;
  padding-bottom: 1rem;
  width: 100%;
  background-color: #ffffff;

  h5 {
    font-size: 1.125rem;
    margin-bottom: 2rem;

    span {
      display: inline-block;
      text-indent: 0.5rem;
      font-weight: 400;
      font-size: 1rem;
    }
  }

  ul {
    margin-bottom: 0;
  }

  li {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.4rem;

    .view-details {
      color: $text-light-blue;
      cursor: pointer;
    }
  }
}

.mobile.wrapper {
  width: 100%;
}
</style>
